import { render, staticRenderFns } from "./bubble.vue?vue&type=template&id=1bb09a52&"
import script from "./bubble.vue?vue&type=script&lang=js&"
export * from "./bubble.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.4.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "bubble.vue"
export default component.exports